import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'
import { PrimaryButton } from '../../components/lease/PrimaryButton'

// Landlord landing screen — plain, on-brand, NOT marketing-heavy (the
// marketing site is separate). Short intro + a single CTA into the flow.
export function Home() {
  const navigate = useNavigate()

  return (
    <Screen className="text-center">
      <header className="animate-fade-in">
        <BrandHeading className="text-4xl">LeaseCheck for Landlords</BrandHeading>
        <p className="mt-4 text-slate-600 dark:text-slate-300">
          Review your lease against Colorado landlord-tenant law and get a redline draft
          for attorney review before you send it out.
        </p>
      </header>

      <PrimaryButton onClick={() => navigate('/onboarding')} className="mt-8 animate-slide-in">
        Get started
      </PrimaryButton>

      <p className="mt-6 text-xs text-slate-500 dark:text-slate-400">
        LeaseCheck screens Colorado leases for common compliance issues. It is not legal
        advice.
      </p>
    </Screen>
  )
}

export default Home
